var _defs, _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.088123 20.088123",
    xmlSpace: "preserve",
    width: 20.088123,
    height: 20.088123,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs32"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 19.563124,3.2631236 3.2631236,19.563124 c -0.7,0.7 -1.9,0.7 -2.69999998,0 v 0 c -0.7,-0.7 -0.8,-2 0,-2.7 L 16.863124,0.56312362 c 0.7,-0.7 1.9,-0.7 2.7,0 v 0 c 0.7,0.79999998 0.7,1.99999998 0,2.69999998 z",
    id: "path25",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 16.863124,19.563124 0.56312362,3.2631236 c -0.7,-0.7 -0.7,-1.9 0,-2.69999998 v 0 c 0.69999998,-0.7 1.99999998,-0.8 2.69999998,0 L 19.563124,16.863124 c 0.7,0.7 0.7,1.9 0,2.7 v 0 c -0.8,0.7 -2,0.7 -2.7,0 z",
    id: "path27",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.86e720c0122fe6c0d651b17116b83971.svg";
export { ForwardRef as ReactComponent };